import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/insumo';
import Insumo from './InsumoList';


const ms2p = (state) => {
    return {
        ...state.insumo,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Insumo);